import { gql } from 'urql'

export const fetchKapProgramYearlyReportsKpi = gql`
  query fetchKapProgramYearlyReportsKpi(
    $measureId: Int!
    $language: String!
    $process: jsonb!
    $level: jsonb!
    $featureSortingConfig: feature_sorting_config_bool_exp!
    $featureGroupSortingConfig: feature_group_sorting_config_bool_exp!
    $featureTypeSortingConfig: feature_type_sorting_config_bool_exp!
  ) {
    feature_config(
      where: {
        _and: {
          feature_values: { feature_base: { kap_measures: { id: { _eq: $measureId } } } }
          has_kpi_for_levels: { _contains: $level }
          has_kpi_for_processes: { _contains: $process }
        }
      }
    ) {
      names(path: $language)
      tooltips(path: $language)

      feature_sorting_configs(where: $featureSortingConfig, order_by: { sort_order: asc }) {
        sort_order
      }

      feature_group_config {
        feature_group_sorting_configs(where: $featureGroupSortingConfig, order_by: { sort_order: asc }) {
          sort_order
        }
      }

      feature_type_config {
        feature_type_sorting_configs(where: $featureTypeSortingConfig, order_by: { sort_order: asc }) {
          sort_order
        }

        names(path: $language)
      }

      feature_values {
        other_description
      }
    }
    kap_measure_kpi_annual_report(
      where: { kap_measure_id: { _eq: $measureId } }
      order_by: { milestone: { year_in_focus: asc } }
    ) {
      actual_value
      feature_config {
        names(path: $language)
        tooltips(path: $language)

        feature_type_config {
          names(path: $language)
        }

        feature_values {
          other_description
        }
      }
      milestone {
        year_in_focus
      }
    }
  }
`
